import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useHttpHook from "../../Hooks/HttpHook";
import { AddPromoCodeApi } from "../../utils/ApiConstant";
import { PromocodeLanguage } from "../../utils/Languages";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import InfiniteProgressBar from "../Common/InfiniteProgressBar";
import ModalWrapper from "../Common/Portals/ModalWrapper";
import Input from "../UiElement/FormElement/Input";
import Select from "react-select";
import { toast } from "react-toastify";
import { promoCodeSelectStyles } from "./promoCodeSelectStyles";
import PromoCodeDateField from "./PromoCodeDateField";
import { showErrorToast } from "../../utils/notify";

const AddPromocodeModel = ({ closeAddModel, getPromocodes, events }) => {
  const [loading, sendRequest, error, successmessage] = useHttpHook();
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type: "percentage",
    },
  });
  const [selectetEvents, setSelectedEvents] = useState([]);
  const [validationErr, setValidationErr] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (successmessage) {
      closeAddModel();
    }
  }, [successmessage, closeAddModel]);

  useEffect(() => {
    setOptions(
      (events || [])
        .filter((event) => {
          const endDate = event?.eventTiming?.endDate;
          return !endDate || new Date(endDate) >= new Date();
        })
        .map((event) => ({
          value: event._id,
          label: event.title,
        }))
    );
  }, [events]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const onSubmit = async (data) => {
    if (selectetEvents.length < 1) {
      toast.error("Please select at least one event");
      return;
    }

    if (data.type === "fixed" && +data.discount >= +data.minPurchase) {
      setValidationErr(
        "Discount should be less than the minimum purchase amount"
      );
      setTimeout(() => {
        setValidationErr("");
      }, 3000);
      return;
    }

    const trimmedPromoCode = getValues("promocode").trim();
    setValue("promocode", trimmedPromoCode);

    const obj = {
      ...data,
      promocode: trimmedPromoCode,
      events: selectetEvents?.map((event) => event.value),
    };

    const res = await sendRequest(AddPromoCodeApi, {
      method: "POST",
      data: obj,
    });

    if (res?.status === 1) {
      await getPromocodes();
      closeAddModel();
    }
  };

  const fieldProps = {
    CustomFormGroupCls: "event-promo-code-field",
    InputClassName: "event-promo-code-input",
    LabelCls: "event-promo-code-label",
    WrapperClass: "",
  };

  return (
    <MainComponentWrapper>
      {loading ? (
        <InfiniteProgressBar />
      ) : (
        <ModalWrapper
          title={PromocodeLanguage.AddPromocodeForm.FormTitle}
          submitText={PromocodeLanguage.AddPromocodeForm.SubmitText}
          CloseModalHandler={closeAddModel}
          formId="add-promocode"
          dialogClassName="event-promo-code-modal-dialog"
          contentClassName="event-promo-code-modal"
          headerClassName="event-promo-code-modal-header"
          bodyClassName="event-promo-code-modal-body"
          footerClassName="event-promo-code-modal-footer"
          closeClass="event-promo-code-modal-btn-close"
          submitClass="event-promo-code-modal-btn-save"
        >
          <form
            className="event-promo-code-form"
            id="add-promocode"
            onSubmit={handleSubmit(onSubmit)}
          >
            {validationErr && (
              <div className="event-promo-code-alert">{validationErr}</div>
            )}

            <div className="event-promo-code-field">
              <label className="event-promo-code-label" htmlFor="promo-events-select">
                Select Events*
              </label>
              <Select
                inputId="promo-events-select"
                value={selectetEvents}
                onChange={(value) => setSelectedEvents(value || [])}
                options={options}
                isMulti
                isSearchable
                isClearable
                placeholder="Select Events"
                name="events"
                classNamePrefix="event-promo-select"
                styles={promoCodeSelectStyles}
              />
            </div>

            <Input
              {...fieldProps}
              ValidationArr={[{ Type: "required" }]}
              element="text"
              FieldName="promocode"
              Register={register}
              Errors={errors}
              placeholder={
                PromocodeLanguage.AddPromocodeForm.FormLabal.promocode.placeHolder
              }
              Label={PromocodeLanguage.AddPromocodeForm.FormLabal.promocode.label}
            />

            <Input
              {...fieldProps}
              ValidationArr={[{ Type: "required" }]}
              element="number"
              FieldName="discount"
              Register={register}
              Errors={errors}
              placeholder={
                PromocodeLanguage.AddPromocodeForm.FormLabal.discount.placeHolder
              }
              Label={PromocodeLanguage.AddPromocodeForm.FormLabal.discount.label}
              max="100"
            />

            <Input
              {...fieldProps}
              ValidationArr={[{ Type: "required" }]}
              element="number"
              FieldName="minPurchase"
              Register={register}
              Errors={errors}
              placeholder={
                PromocodeLanguage.AddPromocodeForm.FormLabal.minPurchase.placeHolder
              }
              Label={
                PromocodeLanguage.AddPromocodeForm.FormLabal.minPurchase.label
              }
            />

            <PromoCodeDateField
              register={register}
              errors={errors}
              label={
                PromocodeLanguage.AddPromocodeForm.FormLabal.expiryDate.label
              }
            />

            <div className="event-promo-code-field">
              <span className="event-promo-code-type-label">
                {PromocodeLanguage.AddPromocodeForm.FormLabal.type.label}
              </span>
              <div className="event-promo-code-radios">
                <label className="event-promo-code-radio">
                  <input
                    type="radio"
                    value="percentage"
                    {...register("type")}
                  />
                  Percentage
                </label>
                <label className="event-promo-code-radio">
                  <input type="radio" value="fixed" {...register("type")} />
                  Fixed Amount
                </label>
              </div>
            </div>
          </form>
        </ModalWrapper>
      )}
    </MainComponentWrapper>
  );
};

export default AddPromocodeModel;
